
function ArchiveJewel(){

    let that = this;
    let carousel = $('.carousel');

    let slider = $('.main-slider').slick({
        fade: true,
        arrows: false,
        infinite: true,
        speed: 1000
    })
    .on('beforeChange', function(event, slick, currentSlide, nextSlide){

        that.slideChange(nextSlide);
        $('.slick-current').addClass('slick-change');
        $('.slick-slide:eq('+nextSlide+')').addClass('slick-visible');

    })
    .on('afterChange', function(event, slick, currentSlide){

        $('.slick-change').removeClass('slick-change slick-visible');

    });

    $('.main-slider-navigation-dots').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        slider.slick('slickGoTo', $(this).index());
    });

    $('.main-slider-navigation--next').on('click', function(){
        slider.slick('slickNext');
    });

    $('.main-slider-navigation--prev').on('click', function(){
        slider.slick('slickPrev');
    });

    $('.main-slider .link-label').each(function(){
        let elem = $(this);
        let splitText = new SplitText(elem, {
            type: "chars"
        });

        splitText.chars.forEach(function (char, index){
            char.style.transitionDelay = 0.2 + index / 20 + 's';
        });
    });

    if( hasTouch ){
        $('.main-slider-navigation li').on('click', function(){
            $('.main-slider-navigation').toggleClass('open');
        });
    }

}

ArchiveJewel.prototype.slideChange = function( index ){
    $('.main-slider-navigation-dots').removeClass('main-slider-navigation-dots--current');
    $('.main-slider-navigation-dots:eq(' + index + ')').addClass('main-slider-navigation-dots--current');
};
